import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../../contexts/AuthContext";

/*
  실제 서비스를 지원하는 페이지로 이동해서 카드 등록을 진행합니다.
*/
export default function PurchaseKakaoauth() {
  useEffect(() => {
    async function registerBillingKey() {
      const params = new URL(window.location.href).searchParams;
      const customerKey = params.get("customerKey");
      const authKey = params.get("authKey");

      window.location.href = `https://answerit.info/callback/purchase?customerKey=${customerKey}&authKey=${authKey}`;
      // window.location.href = `https://auth99.com/register/card?customerKey=${customerKey}&authKey=${authKey}`;
    }

    registerBillingKey();
  }, []);

  return null;
}
